/**
 * Quality Co-Pilot conversation-history helpers.
 *
 * A thin, door-specific binding of the SHARED store + relative-time formatter in
 * components/agentConsole/conversationHistory.ts — so the Co-Pilot page (and its
 * tests) import the qcp-prefixed (`cm_qcp_convid_{userId}`) functions unchanged.
 * The shared store remembers the active conversation PER USER so a refresh
 * resumes the last thread and a shared browser never crosses two staff members'
 * streams.
 */
import {
  formatRelativeTime,
  makeActiveConvStore,
} from '../components/agentConsole/conversationHistory';

export { formatRelativeTime };

const store = makeActiveConvStore('cm_qcp_convid_');

/** Per-user localStorage key for the active Co-Pilot conversation id. */
export const qcpActiveConvKey = store.key;
/** Read the remembered active Co-Pilot conversation id for this user (or null). */
export const readActiveConversationId = store.read;
/** Persist (or, with null, clear) the active Co-Pilot conversation id. */
export const writeActiveConversationId = store.write;
